// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1VzQK","head":"ProcedureTableInfo_head__2EZtj"};